import React from 'react';
export const CFIconSearchCircle = {
    alias: 'search-circle',
    defaultTitle: 'Search Circle',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { fillRule: 'evenodd', d: 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-.5-13A2.503 2.503 0 0 0 9 11.5c0 1.379 1.121 2.5 2.5 2.5s2.5-1.121 2.5-2.5S12.879 9 11.5 9Zm2.86 4.732 1.51 1.51a.444.444 0 1 1-.629.628l-1.51-1.51a3.534 3.534 0 0 1-2.175.751A3.56 3.56 0 0 1 8 11.555 3.56 3.56 0 0 1 11.556 8a3.56 3.56 0 0 1 3.555 3.556c0 .82-.282 1.574-.75 2.176Z', clipRule: 'evenodd' }))),
};
